export enum RankType {
    Gold = 'gold',
    Silver = 'silver',
    Bronze = 'bronze',
    Paper = 'paper',
}

export type RankProps = {
    rank: number;
};
